import { render, staticRenderFns } from "./watermeterchoice.vue?vue&type=template&id=b5fdf8e0&"
import script from "./watermeterchoice.vue?vue&type=script&lang=ts&"
export * from "./watermeterchoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "watermeterchoice.vue"
export default component.exports